export default __webpack_public_path__ + "static/media/facebook.7abca59d.svg";